var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCombinedShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494C4C",
    fillRule: "nonzero",
    d: "M13.578 0c1.057 0 1.903.829 1.903 1.841V18.16c0 1.023-.856 1.841-1.903 1.841H1.903C.853 20 0 19.174 0 18.159V5.565h3.849c1.05 0 1.903-.826 1.903-1.841V0zm-3.243 13.904H5.146a.596.596 0 0 0-.605.586c0 .323.27.586.605.586h5.19a.596.596 0 0 0 .605-.586.596.596 0 0 0-.606-.586zm0-3H5.146a.596.596 0 0 0-.605.586c0 .323.27.586.605.586h5.19a.596.596 0 0 0 .605-.586.596.596 0 0 0-.606-.586zm0-3H5.146a.596.596 0 0 0-.605.586c0 .323.27.586.605.586h5.19a.596.596 0 0 0 .605-.586.596.596 0 0 0-.606-.586zM4.541 0v3.724c0 .369-.31.67-.692.67H0v-.042c0-.156.064-.305.177-.415L4.07.172A.616.616 0 0 1 4.497 0h.044z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedShape);
export default __webpack_public_path__ + "static/media/combined-shape.77af93fca2119be24dfdf0de00b7fb10.svg";
export { ForwardRef as ReactComponent };